<template>
  <div>
    <b-row>
      <b-col>
        <created-receipts />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CreatedReceipts from './ReceiptHistory/CreatedReceipts'

export default {
  components: {
    CreatedReceipts,
  }
}
</script>
<style>
</style>
